// extracted by mini-css-extract-plugin
export default {"itemValue":"itemValue---ENge3","removeBtn":"removeBtn---MNUwe","removeIconRoot":"removeIconRoot---VCger","removeIcon":"removeIcon---Xkpus"};